<template>
  <BaseCard
    class="dreamCardListItem c-pointer w-full"
    elevation="1"
  >
    <BaseLink :href="`${item.url}`">
      <BaseCardHeader>
        <h3>
          {{ index }}. {{ item.name }}
        </h3>
      </BaseCardHeader>
      <BaseFlex>
        <div class="img-container">
          <img
            class="img"
            :src="item.img"
          >
        </div>
        <div
          class="chartContainer"
          style=""
        >
          <BaseChartRadar
            :chart-data="chartDataRadar"
            :options="chartOptionsRadar"
          />
        </div>
      </BaseFlex>
    </BaseLink>
  </BaseCard>
</template>

<script setup>
import useRadarChartOptions from '@/src/vue/utils/useRadarChartOptions';
import BaseChartRadar from '../Base/BaseChartRadar.vue';
import BaseCard from '../Base/BaseCard.vue';
import BaseCardHeader from '../Base/BaseCardHeader.vue';

const props = defineProps({
	item: {
		type: Object,
		default: false
	},
	userPreference: {
		type: Array,
		required: true
	},
	index: {
		type: Number,
		default: 0
	}
});

// const { locale } = useI18n();
const locale = js_params.language || 'sv';

const chartDataRadar = computed(() => {
	return {
		labels: Array.from({ length: 8 }, () => ''),
		datasets: [
			{
				label: '',
				data: props.userPreference,
				fill: false,
				backgroundColor: 'rgba(46, 91, 139, .21)',
				borderColor: 'rgba(46, 91, 139, .6)',
				pointBackgroundColor: '#2e5b8b',
				pointBorderWidth: 2,
				pointRadius: 0,
				pointHoverBorderWidth: 2,
				hoverBackgroundColor: '#f00',
				pointHoverRadius: 8,
				pointHoverBackgroundColor: '#fff',
				pointHoverBorderColor: 'rgb(54, 162, 235)'
			},
			{
				label: '',
				fill: true,
				backgroundColor: 'rgba(46, 91, 139, .21)',
				pointBorderWidth: 2,
				pointRadius: 0,
				pointHoverBorderWidth: 2,
				hoverBackgroundColor: '#f00',
				pointHoverRadius: 8,
				pointHoverBackgroundColor: '#fff',
				pointHoverBorderColor: 'rgb(54, 162, 235)',
				data: props.item
					? [
						Math.min(100, props.item.environmental_performance),
						Math.min(100, props.item.safety),
						Math.min(100, props.item.freedom),
						Math.min(100, props.item.guaranteed_sunshine),
						Math.min(100, props.item.corruption),
						Math.min(100, props.item.internet_connection),
						Math.min(100, props.item.cost_of_living),
						Math.min(100, props.item.language_barriers)
					]
					: randomArray()
			}
		]
	};
});

const chartOptionsRadar = useRadarChartOptions();

function randomArray () {
	return Array.from({ length: 8 }, () => Math.floor(Math.random() * 100) + 1).sort(() => Math.random() - 0.5);
}
</script>

<style scoped>
.img {
  height: 100%;
  object-fit: cover;
  width: 100%;
}
.img-container {
  position: relative;
  width: 100%;
}
.img-container:after {
  bottom: 1rem;
  color: #8ca0b3;
  content: "© TT Nyhetsbyrån AB";
  display: block;
  font-size: 1rem;
  padding: 0.3rem 0.6rem;
  position: absolute;
  right: 0.6rem;
}
a {
  text-decoration: none;
}
.chartContainer {
  margin: 0;
  position: relative;
}
.dreamCardListItem {
  min-width: 25.5rem;
  overflow: hidden;
}
.dreamCardListItem .chartContainer {
  align-items: center;
  display: flex;
  height: 12.5rem;
  justify-content: center;
  min-height: 18.5rem;
  min-width: 12.5rem;
  width: 12.5rem;
}
@media (min-width: 375px) {
  .dreamCardListItem .chartContainer {
    height: 18.5rem;
    min-height: 18.5rem;
    min-width: 18.5rem;
    width: 18.5rem;
  }
}
@media (min-width: 414px) {
  .dreamCardListItem .chartContainer {
    height: 25.5rem;
    min-height: 25.5rem;
    min-width: 25.5rem;
    width: 25.5rem;
  }
  .dreamCardListItem .img-container {
    height: 27rem;
  }
}
</style>
